const url = "https://amazon-app-server-main.vercel.app";
// const url = "http://127.0.0.1:4444"
module.exports = url;

